<span class="c-list-saving-status">
  <span *ngIf="isSaving">
    <i class="fal fa-fw fa-spinner-third fa-spin" aria-hidden="true"></i>
    <span
      i18n="@@listSavingStatus-status-saving"
      class="qa-list-saving-status__status"
      >Saving...</span
    >
  </span>

  <span *ngIf="isSaved">
    <i class="fal fa-fw fa-check" aria-hidden="true"></i>
    <span
      i18n="@@listSavingStatus-status-saved"
      class="qa-list-saving-status__status"
      >Changes saved</span
    >
  </span>
</span>
